/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
export interface CommuterPass {
  id: number;
  type: string;
  startDate: Date;
  endDate: Date;
  cancellationDate: Date;
  departureNodeName: string;
  arrivalNodeName: string;
  lineName: string;
}

export const getCommuterPassByAPIResponse = (commuterPass: any): CommuterPass =>
  ({
    id: commuterPass.id,
    type: commuterPass.type,
    startDate: commuterPass.start_date,
    endDate: commuterPass.end_date,
    cancellationDate: commuterPass.cancellation_date,
    departureNodeName: commuterPass.departure_node_name,
    arrivalNodeName: commuterPass.arrival_node_name,
    lineName: commuterPass.line_name,
  } as CommuterPass);
/* eslint-enable */
